import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../../../common/hookFormComponents/FormSection';

const fields = [
  {
    colSpan: 1,
    name: 'cotYarn',
    type: 'text',
    label: 'Cotton Yarn(kg)',
  },
  {
    colSpan: 1,
    name: 'synthYarn',
    type: 'text',
    label: 'Synthetic Yarn(kg)',
  },
  {
    colSpan: 1,
    name: 'otherYarn',
    type: 'text',
    label: 'Other Yarn(kg)',
  },
];

export const rawMatReqBFieldsValidation = {
  [fields[0].name]: yup.string().label(fields[0].label),
  [fields[1].name]: yup.string().label(fields[1].label),
  [fields[2].name]: yup.string().label(fields[2].label),
};

const RawMatReqB = (props) => {
  return (
    <FormSection
      sectionName="Raw Material Requirement"
      sectionColumn={2}
      formFields={fields}
      {...props}
    />
  );
};

export default RawMatReqB;
